import { ENV } from "../utils";

export class DdOcdeAe {
  baseApi = ENV.BASE_API;

  async getData(accessToken) {
    const response = await fetch(`${this.baseApi}/dd-ae`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async saveData(accessToken, data) {
    const response = await fetch(`${this.baseApi}/dd-ae`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
